module.exports = __webpack_public_path__ + "img/Skilled Communicator.156b7f09.svg";